import triggerOne from '../../trigger/_triggerone.js';
import delegateListener from './index.js';
import forEach from '../../_helpers/foreach.js';
// the function is called when something is added to an array
// it delegates asterisk listener for newly added items
export default function arrayAddHandler(_ref, _temp) {
  var added = _ref.added;
  var _ref2 = _temp === void 0 ? triggerOne.latestEvent.info.delegatedData : _temp,
    path = _ref2.path,
    name = _ref2.name,
    callback = _ref2.callback,
    context = _ref2.context,
    info = _ref2.info;
  forEach(added, function (item) {
    if (item && typeof item === 'object') {
      delegateListener(item, path, name, callback, context, info);
    }
  });
}